(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/overview-earnings-yearly.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/overview-earnings-yearly.js');

'use strict';

const {
  format,
  subYears
} = dateFns;
const {
  getCurrencyType
} = svs.racing.common.strings;
const formatAmount = svs.utils.format;
const YearlyEarnings = _ref => {
  let {
    yearlyEarnings,
    career
  } = _ref;
  const currentYear = yearlyEarnings.currentYear;
  const lastYear = yearlyEarnings.lastYear;
  const labels = ['År', 'Starter', '1:a', '2:a', '3:a', 'Prissumma'];
  const earningRows = [{
    year: format(subYears(new Date(), 1), 'yyyy'),
    starts: lastYear.totalRaces,
    firstPlace: lastYear.totalFirstPlaces,
    secondPlace: lastYear.totalSecondPlaces,
    thirdPlace: lastYear.totalThirdPlaces,
    priceSum: lastYear.earnings,
    currency: yearlyEarnings.currency
  }, {
    year: format(new Date(), 'yyyy'),
    starts: currentYear.totalRaces,
    firstPlace: currentYear.totalFirstPlaces,
    secondPlace: currentYear.totalSecondPlaces,
    thirdPlace: currentYear.totalThirdPlaces,
    priceSum: currentYear.earnings,
    currency: yearlyEarnings.currency
  }, {
    year: 'Totalt',
    starts: career.earnings.totalRaces,
    firstPlace: career.earnings.totalFirstPlaces,
    secondPlace: career.earnings.totalSecondPlaces,
    thirdPlace: career.earnings.totalThirdPlaces,
    priceSum: career.earnings.earnings,
    currency: career.currency
  }];
  return React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "f-500 f-bold margin-bottom-1 margin-top-2"
  }, "Starter"), React.createElement("div", {
    className: "overview-yearly-earnings-header overview-whitebox"
  }, React.createElement("div", {
    className: "yearly-earnings-row"
  }, labels.map(label => React.createElement("div", {
    className: "yearly-earnings-item".concat(label === 'År' ? ' fc-white' : ''),
    key: label
  }, label)))), earningRows.map(row => React.createElement("div", {
    className: "overview-yearly-earnings-row padding-h-1 padding-bottom-1",
    key: row.year
  }, React.createElement("div", {
    className: "yearly-earnings-row"
  }, React.createElement("div", {
    className: "yearly-earnings-item f-medium"
  }, row.year), React.createElement("div", {
    className: "yearly-earnings-item"
  }, row.starts), React.createElement("div", {
    className: "yearly-earnings-item"
  }, row.firstPlace), React.createElement("div", {
    className: "yearly-earnings-item"
  }, row.secondPlace), React.createElement("div", {
    className: "yearly-earnings-item"
  }, row.thirdPlace), React.createElement("div", {
    className: "yearly-earnings-item"
  }, formatAmount.Currency(formatAmount.CurrencyAsJupiterString(row.priceSum)), ' ', getCurrencyType(row.currency))))));
};
svs.racing_game.components.statistics.YearlyEarnings = YearlyEarnings;

 })(window);